import React from 'react';
import styles from './UIGamePlayerInfoToggle.module.scss';
import clsx from 'clsx';
import IconArrow from '@static/images/player_info_toggle_arrow.svg';
export const UIGamePlayerInfoToggle = ({ isActive, setIsActive, children })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.active]: isActive
        }),
        onPointerUp: (e)=>{
            e.preventDefault();
            setIsActive(!isActive);
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, children), /*#__PURE__*/ React.createElement("img", {
        src: IconArrow,
        className: clsx(styles.arrow, {
            [styles.active]: isActive
        })
    }));
